<template>
  <div class="items-center flex">
    <div
      class="bg-white flex items-center px-10 py-8 rounded-16px justify-center"
    >
      <div class="w-full">
        <div class="w-full">
          <div class="flex items-center gap-4 ml-4">
            <img src="@/assets/images/BA 5.png" alt="image" class="w-24" />
            <h2
              class="lg:font-semibold md:font-semibold font-bold lg:text-3xl md:text-2xl text-xl"
            >
              Hi I'm CERA, First things first.<br />
              Let's setup your project.
            </h2>
          </div>
          <div
            class="lg:pl-32 md:pl-8 lg:pr-0 md:pr-8 w-full lg:mt-0 md:mt-0 mt-5"
          >
            <div class="lg:mt-12 md:mt-12 mt-6">
              <div class="relative">
                <input
                  class="input-effect w-full"
                  type="text"
                  placeholder="Project name"
                  v-model="projectField"
                />
                <span class="validate" v-if="this.validateProjectName"
                  >Please fill the required field*</span
                >
                <span
                  :class="{
                    'text-success fsize12': appAvailability.status,
                    'text-danger fsize12': !appAvailability.status,
                  }"
                  >{{ appAvailability.text }}</span
                >
              </div>

              <div class="lg:mt-4 md:mt-4 mt-3 flex lg:items-center">
                <el-popover placement="bottom" width="280" trigger="hover">
                  <p class="fsize12 mb-2 wordbreak-t">
                    You can access the project using this link once its's
                    deployed.
                  </p>
                  <p class="fsize12 wordbreak-t">
                    Apart from checking out the project updates, you'll be also
                    able to use this panel to connect with your virtual team.
                  </p>

                  <div slot="reference">
                    <feather-icon
                      icon="InfoIcon"
                      class="mr-2 cursor-pointer"
                      svgClasses="w-5"
                    />
                  </div>
                </el-popover>

                <p class="fsize12">
                  Great! You will be able to access your admin panel through
                  <span class="font-semibold text-primary">
                    {{ adminLink }}</span
                  >
                  <br />
                  Your project will be first deployed on our staging server with
                  url
                  <span class="font-semibold text-primary">
                    {{ websiteLink }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      projectField: "",
      appAvailability: {},
      trimmedProjectName: "",
    };
  },
  watch: {
    projectField(val) {
      let spaceremoved = val.trim().replace(/ /g, "-").toLowerCase();
      this.trimmedProjectName = spaceremoved;
      this.$store.commit("scope/SET_PROJECT_NAME", val);
      this.$store.commit("scope/SET_ADMIN_LINK", this.adminLink);
      this.$store.commit("scope/SET_WEBSITE_LINK", this.websiteLink);

      this.checkProjectName();
      if (val.length > 0) {
        this.$store.commit("scope/UNSET_VALIDATE_PROJECT_NAME", false);
      }
    },
  },
  computed: {
    ...mapState("scope", ["projectName", "validateProjectName"]),
    ...mapState("admin", ["login"]),
    adminLink() {
      return this.trimmedProjectName
        ? `${this.trimmedProjectName}-admin.brained.in`
        : "{{projectname}}-admin.brained.in";
    },

    websiteLink() {
      return this.trimmedProjectName
        ? `${this.trimmedProjectName}.brained.in`
        : "{{projectname}}.brained.in";
    },
  },
  created() {
    this.projectField = this.projectName;
  },
  mounted() {
    this.$store.commit("scope/SET_CURRENT_PAGE", "pageProject");
  },
  methods: {
    async checkProjectName() {
      if (this.trimmedProjectName && this.trimmedProjectName.length > 2) {
        // const { data } = await this.$store.dispatch("scope/getProject", {
        //   projectName: this.trimmedProjectName,
        // });
        const { data } = await axios.post(
          process.env.VUE_APP_BRAINED_API_URL + "brained/user/findProject",
          { projectName: this.trimmedProjectName }
        );
        if (data && data.length > 0) {
          this.appAvailability = {
            status: false,
            text: "That app name is taken. Try another.",
          };
          this.$emit("projectStatus", this.appAvailability.status);
        } else {
          this.appAvailability = {
            status: true,
            text: "App name is available",
          };
          this.$emit("projectStatus", this.appAvailability.status);
        }
      } else {
        this.appAvailability = {};
      }
    },
  },
};
</script>

<style>
.input-effect {
  border: 0;
  padding: 7px 0;
  border-bottom: 3px solid #ccc;
}

.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
</style>
